/**
 * SegmentedControl Component - Template
 * =======================================
 */

export const SEGMENTED_CONTROL_TEMPLATE: string = `
<div class="ec-segmented-control" ng-class="$ctrl.getContainerClasses()" role="tablist">
  <button
    type="button"
    ng-repeat="option in $ctrl.options track by option.value"
    role="tab"
    ng-attr-aria-selected="{{ option.value === $ctrl.selectedValue ? 'true' : 'false' }}"
    ng-class="$ctrl.getOptionClasses(option)"
    ng-click="$ctrl.handleSelect(option.value)"
  >{{ option.label }}</button>
</div>
`;

export default SEGMENTED_CONTROL_TEMPLATE;
